/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ResolveDisputeData = {
    disputeId: string;
    status: string;
    refundId?: Record<string, any> | null;
    refundStatus?: ResolveDisputeData.refundStatus | null;
    refundError?: Record<string, any> | null;
};
export namespace ResolveDisputeData {
    export enum refundStatus {
        INITIATED = 'initiated',
        FAILED = 'failed',
    }
}

